import React, {ReactNode} from 'react';
import {useParams} from 'react-router-dom';
import {Navigate} from 'react-router';
import {ROUTE_PATHS} from '@di-shared/routes';

export interface DateGuardProps {
  children(date: string): ReactNode;
}

function DateGuard({children}: DateGuardProps): JSX.Element {
  const params = useParams();

  if (!params.date) {
    return (
      <Navigate
        to={ROUTE_PATHS.ERROR.getFullPath()}
        replace
      />
    );
  }

  return <>{children(params.date)}</>;
}

export default DateGuard;
